import { createApi } from '@reduxjs/toolkit/query/react';
import { IDiagnosesItem, IDiagnosesListRequest } from './models';
import { PAGE_SIZE, axiosBaseQuery } from '../common';

const diagnosesURL = 'search';
export const diagnosesApiSlice = createApi({
  reducerPath: 'diagnoses/api',
  baseQuery: axiosBaseQuery({
    baseUrl: 'diagnoses/',
  }),
  endpoints: builder => ({
    getUnselectableDiagnoses: builder.query<IState<IDiagnosesItem>, IDiagnosesListRequest>({
      query: data => ({
        url: diagnosesURL,
        method: 'POST',
        data,
      }),
      keepUnusedDataFor: 0,
      transformResponse: (response: IAxiosResponse<IDiagnosesItem[]>): IState<IDiagnosesItem> => ({
        data: response.data,
        isEnd: response.data.length < PAGE_SIZE,
      }),
    }),
    getDiagnosesByEsbId: builder.query<
      IState<IDiagnosesItem>,
      { search: string; parentDiagnosisEsbId?: Nullable<string>; selectable?: boolean }
    >({
      query: data => ({
        url: diagnosesURL,
        method: 'POST',
        data: { ...data },
      }),
      keepUnusedDataFor: 0,
      transformResponse: (response: IAxiosResponse<IDiagnosesItem[]>): IState<IDiagnosesItem> => ({
        data: response.data,
        isEnd: response.data.length < PAGE_SIZE,
      }),
    }),
    getUnselectableDiagnosesWithoutEbsId: builder.query<IState<IDiagnosesItem>, IDiagnosesListRequest>({
      query: data => ({
        url: diagnosesURL,
        method: 'POST',
        data: { ...data, selectable: false },
      }),
      keepUnusedDataFor: 0,
      transformResponse: (response: IAxiosResponse<IDiagnosesItem[]>): IState<IDiagnosesItem> => ({
        data: response.data,
        isEnd: response.data.length < PAGE_SIZE,
      }),
    }),
  }),
});
